import { render } from "./ProviderSelectTPAComponent.vue?vue&type=template&id=39525120"
import script from "./ProviderSelectTPAComponent.vue?vue&type=script&lang=js"
export * from "./ProviderSelectTPAComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__